import { useEffect, useState } from "react";

export const RbiLandingLinksFetcher = () => {
    const [links, setlinkJson] = useState()
    useEffect(() => {
        fetch(`${window.location.origin}/app/rbilandinglinks.json`)
            .then((res) => {
                return res.json()
            }).then((data) => {
                setlinkJson(data)

            }).catch(err => console.log(err));
    }, []);
    return links
}
